import mutations from './manageRoles.mutations'
import actions from './manageRoles.actions'

const state = {
  roles: [],
  showRolesModal: false,
  isSelectAllFeatures: false,
  editedItemIndex: -1,
  editedItem: {},
  roleDetails: {
    roleId: null,
    roleName: null,
    roleDescription: null,
    clientId: '',
    clientName: null,
    clientNameDesc: null,
    featureCnt: null,
    createdBy: null,
    createdOn: null,
    lastModifiedBy: null,
    lastModifiedOn: null,
    recInactiveFlag: null,
    features: []
  },
  selectedFeatures: [],
  features: {
    landing: [{
      featureId: 28,
      addFeatureId: 24,
      featureName: 'Add Authorizations'
    },
    {
      featureId: 29,
      featureName: 'View Authorizations'
    },
    {
      featureId: 30,
      featureName: 'View Claims'
    },
    {
      featureId: 20,
      featureName: 'Claims Lookup'
    },
    {
      featureId: 65,
      featureName: 'Test Claims Lookup'
    },
    {
      featureId: 27,
      featureName: 'Pharmacy Locator'
    },
    {
      featureId: 31,
      featureName: 'Add Commercial Member'
    },
    {
      featureId: 46,
      featureName: 'Dependents'
    },
    {
      featureId: 32,
      addFeatureId: 47,
      featureName: 'Add Commercial Dependent'
    },
    {
      featureId: 39,
      featureName: 'Add Medicaid Member'
    },
    {
      featureId: 33,
      addFeatureId: 2,
      featureName: 'View/Update Member'
    },
    {
      featureId: 34,
      featureName: 'CDHP'
    },
    {
      featureId: 71,
      featureName: 'Client Documents'
    }
    ],
    view: [{
      viewFeatureId: 6,
      updateFeatureId: 7,
      addFeatureId: 5,
      featureName: 'Eligibility'
    },
    {
      viewFeatureId: 21,
      updateFeatureId: '',
      addFeatureId: '',
      featureName: 'Claims'
    },
    {
      viewFeatureId: 66,
      updateFeatureId: '',
      addFeatureId: '',
      featureName: 'Test Claims'
    },
    {
      viewFeatureId: 23,
      updateFeatureId: '',
      addFeatureId: '',
      featureName: 'Authorizations'
    },
    {
      viewFeatureId: 9,
      updateFeatureId: 10,
      addFeatureId: 8,
      featureName: 'Demographics'
    },
    {
      viewFeatureId: 12,
      updateFeatureId: 13,
      addFeatureId: 11,
      featureName: 'Address'
    },
    {
      viewFeatureId: 15,
      updateFeatureId: 16,
      addFeatureId: 14,
      featureName: 'Phone'
    },
    {
      viewFeatureId: 18,
      updateFeatureId: 19,
      addFeatureId: 17,
      featureName: 'Email'
    },
    {
      viewFeatureId: 36,
      updateFeatureId: 38,
      addFeatureId: 37,
      featureName: 'Aliases'
    },
    {
      viewFeatureId: 40,
      updateFeatureId: 42,
      addFeatureId: 41,
      featureName: 'Conditions'
    },
    {
      viewFeatureId: 43,
      updateFeatureId: 45,
      addFeatureId: 44,
      featureName: 'Attributes'
    },
    {
      viewFeatureId: 48,
      updateFeatureId: 50,
      addFeatureId: 49,
      featureName: 'Third Party Liability'
    },
    {
      viewFeatureId: 54,
      updateFeatureId: 56,
      addFeatureId: 55,
      featureName: 'Regional Reporting'
    },
    {
      viewFeatureId: 51,
      updateFeatureId: 53,
      addFeatureId: 52,
      featureName: 'Long Term Care'
    },
    {
      viewFeatureId: 57,
      updateFeatureId: 59,
      addFeatureId: 58,
      featureName: 'Prescriber Lock Ins'
    },
    {
      viewFeatureId: 62,
      updateFeatureId: 63,
      addFeatureId: 64,
      featureName: 'Pharmacy Lock Ins'
    },
    {
      viewFeatureId: 1,
      updateFeatureId: '',
      addFeatureId: '',
      featureName: 'Member Lookup'
    },
    {
      viewFeatureId: 61,
      updateFeatureId: '',
      addFeatureId: '',
      featureName: 'CDHP'
    },
    {
      viewFeatureId: 67,
      updateFeatureId: '',
      addFeatureId: '',
      featureName: 'ID Cards'
    }
    ]
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
